import { Fragment } from "react";

export interface ResidentHoverRow {
  label: string;
  value?: string | null;
}

interface ResidentHoverCardProps {
  residentName: string;
  rows: ResidentHoverRow[];
}

/**
 * Shared row hover-over card for the MDS and Care Assessments grids (NETSOL-12075).
 *
 * A consistent, consumable layout: the resident's name as a header, then a
 * label/value grid for the fields that were moved off the grid into the hover
 * (Date of Birth, Admission Date, Location, Payor, ...). Both tabs render this
 * so the hover looks and reads the same everywhere.
 */
export function ResidentHoverCard({ residentName, rows }: ResidentHoverCardProps) {
  return (
    <div className="min-w-[240px] max-w-[320px] text-sm">
      <p className="font-semibold text-popover-foreground border-b border-border pb-1.5 mb-1.5">
        {residentName}
      </p>
      <dl className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-1.5">
        {rows.map((r) => (
          <Fragment key={r.label}>
            <dt className="text-muted-foreground">{r.label}</dt>
            <dd className="text-right font-medium text-popover-foreground">
              {r.value || "N/A"}
            </dd>
          </Fragment>
        ))}
      </dl>
    </div>
  );
}
